<div class="map-main-container">
 <app-basic-esri-map
    [inputFilters]="dummyFilters$"
    (mapExtentChanged)="mapExtentChanged($event)"
    (mapDataRequested)="onMapDataRequested($event)"
              [popupTemplateContent]="popupTemplateContent"
          [popupTemplateTitle]="popupTemplateTitle"
          [popupActions]="popupActions"
    [startingExtent]="startingMapVariables.mapExtent"
  ></app-basic-esri-map>
 <wm-common-pagination
  [data]="paginationData"
  (pageSelect)="onPageSelect($event)"
  (pageSizeChange)="onPageSizeChange($event)"
  (first)="onFirst()"
  (previous)="onPrevious()"
  (next)="onNext()"
  (last)="onLast()">
</wm-common-pagination>
</div>
